import React from 'react'

import { Theme } from '../../../../types/shared'
import { ChartEventBadgeType } from '../../../constants/common'
import { IDividends, IEarnings, ISplit } from '../../../utils/chart-events-utils'
import { ChartEventDividendsPopoverContent } from './dividends-popover-content'
import { ChartEventEarningsPopoverContent } from './earnings-popover-content'
import { ChartEventSplitPopoverContent } from './split-popover-content'

interface INoteDialog {
  badgeType: ChartEventBadgeType
  data: ISplit | IDividends | IEarnings
  theme: Theme
}

export function ChartEventPopoverContent({ badgeType, data, theme }: INoteDialog) {
  switch (badgeType) {
    case ChartEventBadgeType.Split:
      return <ChartEventSplitPopoverContent badgeType={badgeType} rawData={data as ISplit} theme={theme} />
    case ChartEventBadgeType.Dividends:
      return <ChartEventDividendsPopoverContent badgeType={badgeType} rawData={data as IDividends} theme={theme} />
    case ChartEventBadgeType.EarningsPositive:
    case ChartEventBadgeType.EarningsNegative:
    case ChartEventBadgeType.EarningsFuture:
    case ChartEventBadgeType.EarningsNeutral:
      return <ChartEventEarningsPopoverContent badgeType={badgeType} rawData={data as IEarnings} theme={theme} />
    default:
      return null
  }
}
